export const environment = {
  version: 'Tasmo-0.21.0',
  production: true,
  redirectUrlForAzure: 'https://evcpostg.km.qa/home',
  serviceUrl: 'https://evcpostg.km.qa/',
  WorkflowAPIUserId: '0980A6DE-FFED-414E-9237-4B4B22420140',
  WorkflowAPIPassword: 'AC74DD84-36AB-4822-83E3-9C4EC19F2B0651CD3F8A-3270-4478-812B-CB998900062A',
  anonymousUserId: '9E8E0A08-F59C-4EC7-B3C3-1213F57BCCFC',
  defaultLanguage: 'en',
  supportedLanguages: ['en- US', 'ar - KW'],
  recaptcha: {
    siteKey: '6LczOt0pAAAAAJAIzHWJWRioZGpO8iqQpv0yOvDf',
  },
};
